/**
 * PLIK GENEROWANY — nie edytuj ręcznie.
 * Źródło: apps/api/scripts/generate-font-coverage.ts
 * Odtworzenie: `pnpm symbols:font-coverage` z apps/api/
 *
 * Codepointy, dla których fonty symboli (IBM Plex Sans, podzbiory latin
 * i latin-ext) mają glify. Builder używa tego do walidacji napisu na żywo,
 * zanim serwer spróbuje zamienić tekst na krzywe. Zeskanowano cały Unicode
 * (U+0020–U+10FFFF) wagą 400 — wagi 400 i 600 mają identyczne pokrycie
 * (patrz komentarz w generatorze), a font w praktyce nie ma nic powyżej
 * U+FFFD.
 */

export const SYMBOL_FONT_CODEPOINTS: readonly number[] = [
  32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47,
  48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63,
  64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79,
  80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95,
  96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111,
  112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 160,
  161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176,
  177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192,
  193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208,
  209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224,
  225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240,
  241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256,
  257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272,
  273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288,
  289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304,
  305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320,
  321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336,
  337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352,
  353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368,
  369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 399,
  402, 416, 417, 431, 432, 461, 462, 463, 464, 465, 466, 467, 468, 469, 470, 471,
  472, 473, 474, 475, 476, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 567,
  601, 699, 700, 710, 711, 730, 732, 733, 768, 769, 771, 772, 776, 777, 803, 7808,
  7809, 7810, 7811, 7812, 7813, 7838, 7922, 7923, 7924, 7925, 7926, 7927, 7928, 7929, 8194, 8201,
  8203, 8211, 8212, 8216, 8217, 8218, 8220, 8221, 8222, 8224, 8226, 8230, 8242, 8243, 8249, 8250,
  8260, 8353, 8356, 8358, 8360, 8361, 8362, 8363, 8364, 8365, 8366, 8369, 8370, 8372, 8373, 8376,
  8377, 8378, 8381, 8383, 8467, 8482, 8593, 8595, 8722, 8725, 65279, 65533,
];

const SUPPORTED = new Set(SYMBOL_FONT_CODEPOINTS);

/** Czy WSZYSTKIE znaki napisu mają glify w foncie symboli. */
export function isGlyphSupported(text: string): boolean {
  for (const char of text) {
    const cp = char.codePointAt(0);
    if (cp === undefined || !SUPPORTED.has(cp)) return false;
  }
  return true;
}

/** Znaki napisu bez glifu — do komunikatu dla użytkownika. */
export function unsupportedGlyphs(text: string): string[] {
  const missing: string[] = [];
  for (const char of text) {
    const cp = char.codePointAt(0);
    if (cp !== undefined && !SUPPORTED.has(cp) && !missing.includes(char)) missing.push(char);
  }
  return missing;
}
